export const GET_ACCESS_TOKEN = "/v1/bus/authenticate";
export const OPERATOR_DETAILS = "/v1/bus/operator/details";
export const GET_PAYOUT_LIST = "/v1/bus/payout/list";
export const DOWNLOAD_REPORT = "/v1/bus/payout/report";
export const GET_USER_LIST = "/v1/ums/users";
export const ADD_USER = "/v1/ums/user";
export const SEARCH_USER_BY_PHONE = "/v1/bus/operator/oauth";
export const UPDATE_USER_ACTIVE_STATUS = "/v1/ums/user/";
export const GET_DEALS_LIST = "/v1/deals";
export const UPDATE_DEALS_STATUS = "/v1/deals/update-status";
export const GET_OPERATOR_ROUTES = "/v1/services/routes";
export const GET_ROUTE_SERVICES = "/v1/services";
export const GET_OPERATOR_SERVICES = "/v1/bus/operator/routes/services";
export const GET_ETM_TRIPS = "/v1/etm/trips";
export const GET_ETM_ROUTES = "/v1/etm/routes";
export const GET_DASHBOARD_DATA = "/v1/bus/operator/transactions";
export const GET_BUS_CATEGORIES_LIST = "/v1/category";
export const GET_PAYTM_CITIES = "/v1/services/getPaytmRoutes";
export const PHONETIC_CITY_SEARCH = "/v2/cities/";
export const GET_SERVICE_SEATLAYOUT = "/v1/deal/seatLayout/fetch";
export const GET_SETLAYOUT = "/v1/deals/seatLayout/fetch";
export const UPDATE_DRIVER_DETAILS =
  "/v1/wrapper/bus/boardingpoints/v1/driver/internal/operator/dashboard";
export const GET_META_DETAILS = "/vas/vas/meta_info";
export const BUS_PHOTO_UPLOAD = "/vas/vas/photos/upload";
export const INVENTORY_REFRESH_URL = "/v1/services/refresh";
export const GET_ALL_ROUTES_INFO = "/v1/bus/operator/routes/info";
export const GET_ESCALATION_MATRIX = "/v1/bus/operator/BD_RL/info";
export const FREE_CANCELLATION = "/v1/free-cancellation";
export const REFRESH_DEAL = "/v1/deals/refresh";
export const GET_RATING_LIST = "/v1/bus/operator/routes/rnr";
export const GET_OPERATOR_DASHBOARD_RATINGS = "/vas/ratings/view";
export const GET_ROUTE_RATINGS_DETAILS = "/vas/service/reviews/view";
export const GET_DEAL_AUDIT_LIST = "/v1/deals/audit-logs";
export const GET_INVENTORY_VIEW = "/v1/inventory/calender/view";
export const GET_INVENTORY_ROUTE_LEVEL_VIEW = "/v1/inventory/route/level/view";
export const INVENTORY_ALL_ROUTES_REFRESH =
  "/v1/inventory/calender/routes/refresh";
export const REJECTION_REASONS = "/v1/inventory/rejected/service/level/view";
export const DOWNLOAD_CUMULATIVE_PAYOUT_LIST = "/v1/bus/payout/report";
export const DOWNLOAD_INVENTORY_CSV = "/v1/inventory/route/level/view/download";
export const FETCH_DEAL_LIST = "/v1/deals/types";
export const BENCCH_MARKING_DATA = "/v1/deals/bench-marking-view";
export const FETCH_TOP_ROUTES = "/v1/deals/route-wise-aggregate";
export const GET_FETCH_DATA = "/v1/deals/GET_FETCH_DATA";
export const FETCH_AGGREGATE_DATA = "/v1/deals/aggregate";
export const FETCH_DEALS_SUMMARY = "/v1/deals/summary";
export const FETCH_DATE_WISE_AGGREGATE = "/v1/deals/date-wise-aggregated-view";
export const FETCH_V2_CITIES = "/v2/cities";
export const DASHBOARD_DOWNLOAD_REPORT = "/v1/internal/transaction/download";
export const DOWNLOAD_PDF = "/v1/bus/payout/report/pdf";
export const DOWNLOAD_CUMULATIVE_PDF = "/v1/bus/payout/list/pdf";
export const GET_POPULAR_STOPS = "/v1/rest-stops";
export const ADD_REST_STOPS = "/v1/rest-stops/service";
export const SEARCH_CITY_PLACES = "/bus-gps/v1/location/search";
export const GET_UNREVIEWED_ORDERS = "/v1/bus/operator/unreviewed/orders/rnr";
export const NOTFICATION_URL = "/v1/bus/operator/notification/rnr";
export const GET_PAYTM_ASSURED_CLAIM_REPORT =
  "/v1/bus/payout/assured/claim/report";
